import {createAction, props} from '@ngrx/store';

export const loadRegisters = createAction(
  '[Register] Load Registers'
);

export const registerNewUser = createAction(
  '[Register] Register New User',
  props<{ registerFrom: any }>()
);
export const registerNewUserSuccess = createAction(
  '[Register] Register New User Success'
);

export const registerNewUserPreConfirm = createAction(
  '[Register] Register New User Require Confirm',
  props<{ code: number, error: string }>()
);

export const registerNewUserConfirm = createAction(
  '[Register] Register New User Confirm',
  props<{ registerForm: any }>()
);
export const registerNewUserFailed = createAction(
  '[Register] Register New User Failed',
  props<{ code: number, error: string }>()
);





